import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CorpStyle} from "./corpStyle";


const routes: Routes = [
  {
    path: 'corpStyle',
    component: CorpStyle,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorpStyleRoutingModule {}
